import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { DataExportActions } from "@/features/settings/components/data-export-actions"
import { DataExportLatest } from "@/features/settings/components/data-export-latest"
import { DataExportNotice } from "@/features/settings/components/data-export-notice"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/export/"
)({
  component: DataExportSettingsPage,
})

function DataExportSettingsPage() {
  return (
    <>
      <PageHeader title="Export data" actions={<DataExportActions />} />
      <PageContent className="max-w-none gap-8">
        <DataExportNotice />
        <DataExportLatest />
      </PageContent>
    </>
  )
}
